// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PromoCode = function (x) {
    return x;
};
var tsBridgePromoCode = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("PromoCode")("__brandPromoCode"));
    }
};
var writePromoCode = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showPromoCode = Data_Show.showString;
var readPromoCode = Simple_JSON.readString;
var ordPromoCode = Data_Ord.ordString;
var newtypePromoCode = {
    Coercible0: function () {
        return undefined;
    }
};
var makePromoCode = PromoCode;
var eqPromoCode = Data_Eq.eqString;
export {
    PromoCode,
    makePromoCode,
    unwrap,
    newtypePromoCode,
    eqPromoCode,
    ordPromoCode,
    showPromoCode,
    readPromoCode,
    writePromoCode,
    tsBridgePromoCode
};
//# sourceMappingURL=index.js.map
